/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { ReportType } from '../types/ReportType';
import { ReportFormControl } from '../types/ReportFormControl';
import { SortBy } from '../types/SortBy';

export const reportsFormTypeConfig = {
	[ReportType.ConstraintLog]: [
		ReportFormControl.ReportType,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.IncludeCompleted,
		ReportFormControl.OnlyLate,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.SortBy,
		ReportFormControl.BreakUpBy,
		ReportFormControl.CustomFields,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.DraftTickets]: [ReportFormControl.ReportType],
	[ReportType.ExportToCSV]: [
		ReportFormControl.ReportType,
		ReportFormControl.CSVExportType,
		ReportFormControl.CSVPlan,
	],
	[ReportType.GanttChart]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.EndDate,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.IncludeCompleted,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.SortBy,
		ReportFormControl.GroupBy,
		ReportFormControl.SortGroupsBy,
		ReportFormControl.BreakUpBy,
		ReportFormControl.TimeScale,
		ReportFormControl.CustomFields,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.WbsGroupingLevel,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.OverdueActivity]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.SortBy,
		ReportFormControl.GroupBy,
		ReportFormControl.SortGroupsBy,
		ReportFormControl.BreakUpBy,
		ReportFormControl.TimeScale,
		ReportFormControl.CustomFields,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.WbsGroupingLevel,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.PPCReport]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.EndDate,
		ReportFormControl.PpcFormat,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.BreakUpBy,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.SixWeekLookAhead]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.IncludeCompleted,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.SortBy,
		ReportFormControl.GroupBy,
		ReportFormControl.SortGroupsBy,
		ReportFormControl.BreakUpBy,
		ReportFormControl.CustomFields,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.WbsGroupingLevel,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.BasicVarianceReason]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.NumberOfWeeks,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.SortBy,
		ReportFormControl.GroupBy,
		ReportFormControl.BreakUpBy,
		ReportFormControl.CustomFields,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.WbsGroupingLevel,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.AdvancedVarianceReason]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.EndDate,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.GroupBy,
		ReportFormControl.BreakUpBy,
		ReportFormControl.CustomFields,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.WbsGroupingLevel,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.WeeklyWorkPlan]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.NumberOfWeeks,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.IncludeCompleted,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.SortBy,
		ReportFormControl.GroupBy,
		ReportFormControl.SortGroupsBy,
		ReportFormControl.BreakUpBy,
		ReportFormControl.CustomFields,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.WbsGroupingLevel,
		ReportFormControl.ArchivedPlansDropDown,
	],
	[ReportType.ExportTickets]: [
		ReportFormControl.ReportType,
		ReportFormControl.AsOfDate,
		ReportFormControl.EndDate,
		ReportFormControl.Roles,
		ReportFormControl.Plans,
		ReportFormControl.Locations,
		ReportFormControl.Swimlanes,
		ReportFormControl.IncludePullTickets,
		ReportFormControl.ExternalLinkage,
		ReportFormControl.FilterByCustomFieldsToggle,
		ReportFormControl.CustomField1,
		ReportFormControl.CustomField2,
		ReportFormControl.CustomField3,
		ReportFormControl.ExportFormatType,
		ReportFormControl.ExportFormatTemplate,
		ReportFormControl.IncludeWBSCodeFilterToggle,
		ReportFormControl.WbsCodeFilterConfig,
		ReportFormControl.ArchivedPlansDropDown,
	],
};

export const reportFormSortByConfig = {
	[ReportType.GanttChart]: [SortBy.Date, SortBy.Role],
	[ReportType.ConstraintLog]: [SortBy.Date, SortBy.Role],
	[ReportType.DraftTickets]: [SortBy.Date, SortBy.Role],
	[ReportType.OverdueActivity]: [SortBy.Date, SortBy.Role],
	[ReportType.SixWeekLookAhead]: [SortBy.Date, SortBy.Role],
	[ReportType.BasicVarianceReason]: [SortBy.Date, SortBy.Role],
	[ReportType.AdvancedVarianceReason]: [SortBy.Date, SortBy.Role],
	[ReportType.WeeklyWorkPlan]: [SortBy.Date, SortBy.Role],
};
